import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "./config/muiLicense";
import { PublicClientApplication, InteractionStatus } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import msalConfig from "./auth/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

async function initializeAndRender() {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<div style={{ textAlign: "center", marginTop: "25vh" }}>Initializing authentication...</div>);

  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise(); // ✅ required once globally

    root.render(
      <React.StrictMode>
        <MsalProvider instance={msalInstance}>
          <App />
        </MsalProvider>
      </React.StrictMode>
    );
  } catch (error) {
    console.error("MSAL initialization failed:", error);
    root.render(<div style={{ color: "red" }}>Failed to initialize authentication</div>);
  }
}

initializeAndRender();
reportWebVitals();
